'use es6';

import { Map as ImmutableMap } from 'immutable';
import Ads from '../models/Ads';
import { REQUESTED_ADS_DATA, REQUESTED_ADS_DATA_FAILED, RECEIVED_ADS_DATA } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
const initialState = ImmutableMap({
  data: new Ads()
});
export default ((state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_ADS_DATA:
      return state.setIn(['data', 'status'], RequestStatus.PENDING);
    case REQUESTED_ADS_DATA_FAILED:
      return state.setIn(['data', 'status'], RequestStatus.FAILED);
    case RECEIVED_ADS_DATA:
      return state.mergeIn(['data'], action.payload.data);
    default:
      return state;
  }
});